(function mainNavResponsiveMove($, Drupal) {
    Drupal.behaviors.shopnav = {
        attach: function (context, settings) {
            var $header = $('.header');
            var $shopNav = $('#oo-navi', context);
            var $oc = $('#offCanvas', context);

            $(window).resize(function () {
                moveMainNav();
            });

            $(document).ready(function () {
                moveMainNav();
            });

            function moveMainNav() {

                if ($(window).width() < 1100) {
                    //Mobile
                    $oc.prepend($shopNav);
                    $shopNav.addClass('shop-nav--mobile')
                    console.log('mobile');
                }
                else {
                    //Desktop
                    $shopNav.removeClass('shop-nav--mobile')
                    $header.append($shopNav);
                    console.log('Tablet & Desktop');
                }
            }
            $shopNav.each(function (e) {
                // console.log($shopNav);
            });
            $shopNav.on("click", ".oo-shop-item-permalink", function () {
                // console.log('close off canvas');
                $oc.foundation('close');
            });

        }
    };
}(jQuery, Drupal));
